var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCircleLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 22.5,
    height: 22.5,
    rx: 11.25,
    stroke: "#506C8E",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7213 12.6414C17.76 12.4413 17.76 12.2054 17.76 11.9848V11.9592C17.7324 8.58923 15.3963 6.24 12.1601 6.24C8.76378 6.23487 6.23999 8.57384 6.23999 12.0002C6.23999 15.4266 8.74169 17.7553 12.2651 17.7553C14.0829 17.8208 15.8512 17.1968 17.1636 16.0267L16.1585 14.8675C15.1352 15.7599 13.7846 16.2569 12.381 16.2576C11.305 16.3006 10.2549 15.943 9.46383 15.2641C8.67275 14.5852 8.20608 13.6411 8.16735 12.6414H17.7213ZM8.19167 11.2052H8.18931V11.2206C8.19009 11.2155 8.19088 11.2103 8.19167 11.2052ZM8.19167 11.2052H15.8435C15.6061 9.13809 14.1536 7.81985 12.1214 7.81985C9.91801 7.81985 8.50034 9.21298 8.19167 11.2052Z",
    fill: "#506C8E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleLogo);
export default __webpack_public_path__ + "static/media/Circle_Logo.dc9569b0f4f4147c5bba87c00bc3590b.svg";
export { ForwardRef as ReactComponent };